import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import api from "../Services/apiComunicacao";
import { io, Socket } from "socket.io-client";
import { baseUrlSocket, pathSocket } from "../Utils/baseUrl";
import { setEnvironmentData } from "worker_threads";
import { isRural } from "../Utils/isRural";

export interface IComunicacao {
  ID: number;
  FUNCIONARIO_CARTORIO_ID: number;
  FUNCIONARIO_PREFEITURA_ID: number;
  IMOVEL_ID: number;
  MENSSAGEM: string | null;
  CRIACAO: Date;
  IDENTIFICADOR: string | null;
  CARTORIO_ID:number;
}

interface IComunicacaoContextData {
  comunicacao: IComunicacao[];
  getComunicacao(imovel_id: number, lastMessageId: number): Promise<void>;
  addComunicacao(comunicacao: IComunicacao): void;
  acabou: boolean;
  addAnexoComunicacao(
    anexo: IAnexoComunicacao,
    messageList: IComunicacao[]
  ): void;
  handleCloseComunicacao(): void;
}

interface IComunicacaoProviderProps {
  children: ReactNode;
}

export interface IAnexoComunicacao {
  IDENTIFICADOR: string;
  COMUNICACAO_ID: number;
}

const ComunicacaoContext = createContext({} as IComunicacaoContextData);

function ComunicacaoProvider({ children }: IComunicacaoProviderProps) {
  const [comunicacao, setComunicacao] = useState({} as IComunicacao[]);
  const [acabou, setAcabou] = useState(false);
  async function getComunicacao(imovel_id: number, lastMessageId: number) {
    try {
      const { data } = await api.get(`/messages${isRural() ? "-rural" : ""}/${imovel_id}/${lastMessageId}`);

      if (comunicacao) {
        if (comunicacao.length > 0) {
          setComunicacao((prev) => [...data, ...prev]);
        } else {
          setComunicacao(data);
        }
      }
      if (comunicacao.length == 0) setAcabou(true);
    } catch (error) {
      throw error;
    }
  }

  function addAnexoComunicacao(
    anexo: IAnexoComunicacao,
    messageList: IComunicacao[]
  ) {
    console.log("aqui");
    console.log(messageList, anexo);
    for (let index = messageList.length; index >= 0; index--) {
      const element = messageList[index - 1];
      //window.alert(`${element.ID} == ${anexo.COMUNICACAO_ID}`);
      console.log(`${element.ID} == ${anexo.COMUNICACAO_ID}`);
      if (element.ID == anexo.COMUNICACAO_ID) {
        //window.alert(anexo.IDENTIFICADOR);
        element.IDENTIFICADOR = anexo.IDENTIFICADOR;
        setComunicacao(messageList);
        break;
      }
    }
  }

  function handleCloseComunicacao() {
    setComunicacao([
      {
        ID: 0,
        MENSSAGEM: null,
        FUNCIONARIO_CARTORIO_ID: 0,
        FUNCIONARIO_PREFEITURA_ID: 0,
        IMOVEL_ID: 0,
        CARTORIO_ID:0,
        CRIACAO: new Date(),
        IDENTIFICADOR: null,
      },
    ]);
  }

  function addComunicacao(comunicacao: IComunicacao) {
    setComunicacao((prev) => [...prev, comunicacao]);
  }

  useEffect(() => {
    console.log("effect-> ", comunicacao);
  }, [comunicacao]);

  return (
    <ComunicacaoContext.Provider
      value={{
        addAnexoComunicacao,
        getComunicacao,
        comunicacao,
        addComunicacao,
        acabou,
        handleCloseComunicacao,
      }}
    >
      {children}
    </ComunicacaoContext.Provider>
  );
}

function useComunicacao() {
  const context = useContext(ComunicacaoContext);

  return context;
}

export { ComunicacaoProvider, useComunicacao };
